

















































































































































import Vue from "vue";
import { WeightSet } from "@/interfaces/sets.interface";
import { Weights, ExerciseEmitData } from "@/interfaces/exercise.interface";
export default Vue.extend({
  props: {
    exercise: Object,
    exerciseIdx: Number,
  },
  methods: {
    addSetToExercise() {
      let data = {
        exerciseIdx: this.exerciseIdx,
        newSet: {},
      };
      let exerciseType: Weights = this.exercise;
      if (exerciseType) {
        let newSet: WeightSet = {
          weight: 0,
          reps: 0,
          done: false,
        };
        if (exerciseType.sets.length > 0) {
          let copiedSet = exerciseType.sets[exerciseType.sets.length - 1];
          newSet.weight = copiedSet.weight;
          newSet.reps = copiedSet.reps;
        }
        data.newSet = newSet;

        this.$emit("addSetToExercise", data);
      }
    },
    removeSet(setIdx: number) {
      let exerciseEmitData: ExerciseEmitData = {
        exerciseIdx: this.exerciseIdx,
        setIdx,
      };
      this.$emit("removeSet", exerciseEmitData);
    },
    removeExercise() {
      this.$emit("removeExercise", this.exerciseIdx);
    },
  },
  computed: {
    exercyseType(): "Cardio" | "Reps" | "Duration" | "Weights" | undefined {
      let exerciseType = this.exercise.type;
      if (exerciseType === "Cardio") return "Cardio";
      if (exerciseType === "Reps") return "Reps";
      if (exerciseType === "Duration") return "Duration";
      if (
        exerciseType === "Barbell" ||
        exerciseType === "Dumbbell" ||
        exerciseType === "Machine" ||
        exerciseType === "Weighted Bodyweight" ||
        exerciseType === "Assisted Bodyweight"
      )
        return "Weights";

      return undefined;
    },
  },
});
